import useCaseListTable from "../../hooks/useCaseListTable";
import CaseTableRow from "./CaseTableRow";
import SampleCaseRow from "./SampleCaseRow";
import ListTable from "../common/ListTable";
import RenderIf from "../render-if/Renderif";

const actionsHeaderClasses = 'w-action-column min-w-action-column';

const caseTableHeaders = [
    { label: "Case Details", className: "w-[25%]" },
    { label: "", className: "w-[10%]" },
    { label: "Plaintiff", className: "w-[20%]" },
    { label: "Defendant", className: "w-[20%]" },
    { label: "Last Updated", className: "w-[15%]" },
    { label: "Status", className: "w-[10%]" },
    { label: "Actions", className: actionsHeaderClasses },
];

const CaseListTable = ({
    items,
    getCases,
    hasSampleCase = false
}) => {
    const { openCaseId, handleToggle, handleCloseBox, handleDelete } = useCaseListTable({ getCases });

    return (
        <ListTable headers={caseTableHeaders}>
            <RenderIf shouldRender={hasSampleCase}>
                <SampleCaseRow />
            </RenderIf>

            {items?.map((caseData, index) => (
                <CaseTableRow
                    key={caseData._id || index}
                    caseData={caseData}
                    setCaseIdToDelete={handleDelete}
                    openCaseId={openCaseId}
                    handleToggle={handleToggle}
                    handleCloseBox={handleCloseBox}
                    getCases={getCases}
                />
            ))}
        </ListTable>
    );
};

export default CaseListTable;
